import type { QueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { stopAllAudio } from "@/lib/audio-bus";
import { clearOfflinePages } from "@/lib/pwa";

/** Clears private client state before ending the session on a shared device. */
export async function secureSignOut(queryClient?: QueryClient) {
  await queryClient?.cancelQueries();
  queryClient?.clear();
  stopAllAudio();
  await clearOfflinePages();
  return supabase.auth.signOut();
}